import useSWR from 'swr';

import { useConfiguration } from '../contexts';
import { fetcher } from '../utils';

interface Translations {
  [locale: string]: Record<string, string>;
}

interface ContentsResponse {
  DefaultLanguage: string;
  Contents: Translations;
}

enum RegistrationSufixUrlType {
  VipCustomer = 'vipCustomerContent',
  Consultant = 'brandPartnerContent',
}

async function fetchContents(url: string, tenant: string, currentLanguage?: string) {
  const locale = getLocale(currentLanguage);

  const response = await fetcher<ContentsResponse>(url, {
    token: '',
    tenant,
    headers: { 'Accept-Language': locale },
  });

  const { Contents: contents, DefaultLanguage: defaultLanguage } = response;
  const currentLocale = locale.length > 0 ? locale : defaultLanguage;

  return {
    locale: currentLocale || '',
    contents: contents[currentLocale],
  };
}

function getLocale(currentLanguage?: string) {
  if (currentLanguage) {
    return currentLanguage;
  }

  if (document.documentElement.lang) {
    return document.documentElement.lang;
  }

  return navigator.language;
}

export function useContentsQuery() {
  const { tenant, staticApiUrl, currentLanguage, registrationType } = useConfiguration();
  const registrationTypeSufix =
    registrationType === 'VipCustomer' ? RegistrationSufixUrlType.VipCustomer : RegistrationSufixUrlType.Consultant;

  const response = useSWR(
    `${staticApiUrl}/tenants/${tenant}/applications/simplifiedRegistration/${registrationTypeSufix}`,
    async (url: string) => fetchContents(url, tenant, currentLanguage),
  );

  return response;
}
